// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_fY","advertDetailServiceList__header":"c-p_fZ","advertDetailServiceList__list":"c-p_ga"};